import { createFileRoute } from '@tanstack/react-router';
import { PoolsPage } from '../screens/admin/PoolsPage';

export const Route = createFileRoute('/admin/pools')({
  component: PoolsPage,
});
